import { FeedbackEditActionTypes, Action } from "../Actions/FeedbackEditActions";
import { BugReport, FeatureRequest } from "../Models/Feedback";

export interface FeedbackEditState {
  feedback: FeatureRequest | BugReport | null;
  isLoading: boolean;
  contentIsLoaded: boolean;
  hasError: boolean;
  errorCode: number | null;
  errorDescription: string;
}

const initalState: FeedbackEditState = {
  feedback: null,
  isLoading: false,
  contentIsLoaded: false,
  hasError: false,
  errorCode: null,
  errorDescription: ""
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const feedbackEditReducer = (state: FeedbackEditState = initalState, action: Action<any>) => {
  switch (action.type) {
    case FeedbackEditActionTypes.SET_FEEDBACK:
      return updateObject(state, {
        feedback: action.payload,
        contentIsLoaded: true,
        isLoading: false
      });
    case FeedbackEditActionTypes.SET_LOADING:
      return updateObject(state, {
        isLoading: true
      });
    case FeedbackEditActionTypes.RESET_LOADING:
      return updateObject(state, {
        isLoading: false
      });
    case FeedbackEditActionTypes.RESET_LOADED:
      return updateObject(state, {
        contentIsLoaded: false,
        hasError: false,
        errorCode: null,
        errorDescription: ""
      });
    case FeedbackEditActionTypes.SET_ERROR:
      return updateObject(state, {
        hasError: true,
        errorCode: action.payload.errorCode,
        errorDescription: action.payload.errorDescription
      });
    default:
      return state;
  }
};

export default feedbackEditReducer;
